/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useMonarchRule } from '../../../../../components/ui/organisms/monarch/MonarchRulesProvider';
// eslint-disable-next-line import/no-cycle
import {
    CheckoutExampleTestResult,
    CheckoutExampleTestVariant,
    UseCheckoutExampleTestHookResult,
} from './types';

const CUSTOM_RULE_ID = 'checkoutExampleTest';

/**
 * Hook for Example Checkout Test
 *
 * To trigger this manually add a cookie to your browser `edx-checkout-test-value` with value "1".
 *
 * https://admin.monarch.cohesionapps.com/sources/bdac7c16-924e-4180-bb35-5b2dfff6d308/source-overview/rules/4e001b87-db86-46be-bf0c-4615c69f3567/
 */
const useCheckoutExampleTest: UseCheckoutExampleTestHookResult = () => {
    // Call the Monarch API to get the experiment result
    const { isLoading, value } = useMonarchRule<{
        // https://admin.monarch.cohesionapps.com/sources/bdac7c16-924e-4180-bb35-5b2dfff6d308/content/native-returns/5b356d7c-c754-4a61-9bf4-6065a25db4b0/
        showAlternateView: boolean;
    }>(CUSTOM_RULE_ID, {});

    // If still loading or no value returned, return loading state
    if (isLoading || !value) {
        return {
            isLoading,
        } as CheckoutExampleTestResult;
    }

    // Determine the variant based on the returned data
    const variant: CheckoutExampleTestVariant = value?.showAlternateView
        ? 'alternate'
        : 'control';

    // Return the experiment result with proper typing
    return {
        isLoading: false,
        variant,
    };
};

export default useCheckoutExampleTest;
